import { useEffect, useState, useCallback } from "react";
import { listDevices } from "@/lib/zebra";
import { resolveDeviceForMedia, printersForMedia, hydratePrinterConfig, onPrinterMapChange } from "@/lib/printerMap";

// Resolve the target printer for a PHYSICAL MEDIA (hang_tag | sticker | barcode_label).
// The LABEL stays the choice and the printer is derived from it — but the manual override
// can only ever offer printers that HOLD this stock, so a mismatched pair cannot be built
// here at all (and zebra.js refuses one anyway if some other path tries).
export function usePrinterTarget(media) {
  const [devices, setDevices] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [overrideUid, setOverrideUid] = useState(null);
  const [, setMapV] = useState(0);
  // re-render when the config hydrates from the server or changes, so routing re-resolves
  useEffect(() => onPrinterMapChange(() => setMapV((v) => v + 1)), []);

  const reload = useCallback((fresh = false) => {
    setLoaded(false);
    hydratePrinterConfig();
    listDevices(fresh === true).then((l) => { setDevices(l); setLoaded(true); })
      .catch(() => { setDevices([]); setLoaded(true); });
  }, []);
  useEffect(() => { reload(); }, [reload]);
  // A new media selection clears a stale manual override so it re-auto-routes.
  useEffect(() => { setOverrideUid(null); }, [media]);

  const eligible = printersForMedia(media, devices);
  const auto = resolveDeviceForMedia(media, devices);
  // an override is only honoured if that printer holds THIS stock
  const override = overrideUid ? eligible.find((d) => d.uid === overrideUid) : null;
  // NO devices[0] fallback: an unmapped media must NOT silently print on a guessed unit.
  const target = override || auto || null;
  const needsSetup = loaded && devices.length > 0 && !target;

  return { devices, eligible, media, loaded, target, auto, needsSetup, overrideUid, setOverrideUid, reload, isOverridden: !!override };
}
